import type { TypedUseSelectorHook } from 'react-redux';
import { useSelector as defaultUseSelector } from 'react-redux';

export const useSelector = <TRootState extends Record<string, unknown>>(): TypedUseSelectorHook<TRootState> =>
  defaultUseSelector;
